import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Snackbar, Alert, AlertTitle } from "@mui/material";

const GlobalSnackbar = () => {
  const dispatch = useDispatch();

  // Access state (make sure the key matches your rootReducer)
  const snackbarState = useSelector((state) => state.snackbar);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    dispatch({
      type: "HIDE_SNACKBAR",
      payload: {},
    });
  };

  return (
    <Snackbar
      open={snackbarState.open}
      autoHideDuration={3000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={handleClose}
        severity={snackbarState.severity}
        variant="standard"
        sx={{
          width: "400px",
          height: "auto",
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.25)",
          borderRadius: "4px",
        }}
      >
        {snackbarState.title && (
          <AlertTitle sx={{ fontWeight: "bold" }}>
            {snackbarState.title}
          </AlertTitle>
        )}
        {snackbarState.description}
      </Alert>
    </Snackbar>
  );
};

export default GlobalSnackbar;
